import React from 'react';
import './InputCountry.scss';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { getCountryList } from 'Store/User/selectors';
import { fetchCountryList } from 'Store/User/thunks';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import { clearCountryList } from 'Store/User/actions';

interface IProps {
  initialCountryKey: string;
  onChange: (value: string) => void;
}

interface IPropsInternal {
  countries: Julius.Website.CountryItemViewModel[];
  fetchCountryList: () => void;
  clearCountryList: () => void;
}

type Props = IProps & IPropsInternal;

class InputCountry extends React.PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    countries: [],
  }

  componentDidMount() {
    this.props.fetchCountryList();
  }

  componentWillUnmount() {
    this.props.clearCountryList();
  }

  getCountryNames = () => {
    return this.props.countries.reduce((names, country) => {
      return names.concat(country.name);
    }, []);
  }

  getDefaultCountryName = () => {
    const { countries, initialCountryKey } = this.props;
    const country = countries.find(c => c.key === initialCountryKey);
    return country ? country.name : undefined;
  }

  render() {
    const { countries, initialCountryKey, onChange } = this.props;

    if (!countries) {
      return null;
    }

    return (
      <div className='input-country'>
        <FormattedText 
          style='medium-bold'
          displayName='Land'
          formattedName='global.country'
        />
        <select name='country' onChange={ (e) => onChange(e.target.value) }>
          { countries.map((c, i) =>
            <option 
              value={ c.key }
              key={ `${ i }-${ c.key }` } 
              selected={ c.key === initialCountryKey }
            >
              { c.name }
            </option>) 
          }
        </select>
      </div>
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    countries: getCountryList(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchCountryList,
    clearCountryList,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(InputCountry);


// WEBPACK FOOTER //
// ./src/components/InputCountry/InputCountry.tsx